import { NvTooltipModule } from 'Src/ng2/shared/nv-tooltip/nv-tooltip.module';
import { InfoBoxModule } from './../shared-components/info-box/info-box.module';
import { RemoteLearningPanelComponent } from './remote-learning/remote-learning-panel.component';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatCommonModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { NvDesignLibraryModule } from 'Src/nvps-libraries/design/nv-design-library.module';
import { ListDisplayMilestoneModule } from '../../school/lists/list-display/list-display-milestone/list-display-milestone.module';
import { ListDisplayStudentActivitiesModule } from '../../school/lists/list-display/list-display-student-activities/list-display-student-activities.module';
import { SharedServicesModule } from '../../shared/services/shared.services.module';
import { ListDisplayPathModule } from './../../school/lists/list-display/list-display-path/list-display-path.module';
import { NvMatTooltipModule } from './../../shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { AcademicPanelReady } from './student-academic-panel-ems/academic-panel-ready/academic-panel-ready.component';
import { AcademicPanelStateExam } from './student-academic-panel-ems/academic-panel-state-exam/academic-panel-state-exam.component';
import { StudentAcademicPanelEMS } from './student-academic-panel-ems/student-academic-panel-ems.component';
import { StudentAttendancePanel } from './student-attendance-panel/student-attendance-panel.component';
import { StudentBasicInfoPanel } from './student-basic-info-panel/student-basic-info-panel.component';
import { StudentGradPanelV3 } from './student-grad-panel-v3/student-grad-panel-v3.component';
import { StudentPanelComponent } from './student-panel.component';
import { StudentPanelService } from './student-panel.service';
import { StudentPointPeoplePanel } from './student-point-people-panel/student-point-people-panel.component';
import { StudentPostsecPanel } from './student-postsec/student-postsec.component';
import { StudentSupportsPanelV3 } from './student-supports-panel-v3/student-supports-panel-v3.component';

@NgModule({
  declarations: [
    StudentPanelComponent,
    StudentBasicInfoPanel,
    StudentAttendancePanel,
    StudentAcademicPanelEMS,
    StudentPointPeoplePanel,
    StudentSupportsPanelV3,
    AcademicPanelStateExam,
    AcademicPanelReady,
    StudentPostsecPanel,
    StudentGradPanelV3,
    RemoteLearningPanelComponent,
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatCommonModule,
    MatTableModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    ListDisplayMilestoneModule,
    ListDisplayStudentActivitiesModule,
    ListDisplayPathModule,
    NvMatTooltipModule,
    NvTooltipModule,
    NvDesignLibraryModule,
    InfoBoxModule,
    MatExpansionModule,
    NvTooltipModule,
  ],
  providers: [SharedServicesModule, StudentPanelService],
  exports: [
    StudentPanelComponent,
    StudentBasicInfoPanel,
    StudentAttendancePanel,
    StudentAcademicPanelEMS,
    StudentPointPeoplePanel,
    StudentSupportsPanelV3,
    AcademicPanelStateExam,
    AcademicPanelReady,
    StudentPostsecPanel,
    StudentGradPanelV3,
    RemoteLearningPanelComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class StudentPanelsModule {}
